<template>
    <div>
        <h1 class="title is-3 between-center">Lead Center</h1>
        <div class="columns">
            <div class="column is-3">
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Summary</strong>
                  </template>
                    <div class="content full-width">
                        <p class="between-center">
                            <strong>Pending Contacts: </strong>
                            <span>30</span>
                        </p>
                        <p class="between-center">
                            <strong>Pending Proposals: </strong>
                            <span>19</span>
                        </p>
                    </div>
                </b-panel>
            </div>
            <div class="column is-9">
                <o-tabs type="is-boxed">
                    <o-tab-item label="Pending Contacts">
                        <o-table
                            :data="contacts"
                            :bordered="isBordered"
                            :striped="isStriped"
                            :narrowed="isNarrowed"
                            :checkable="isCheckable"
                            :loading="isLoading"
                            :mobile-cards="hasMobileCards"
                            :paginated="isPaginated"
                            :per-page="perPage"
                            :pagination-simple="isPaginationSimple"
                            default-sort="user.first_name"
                            :selected.sync="selected"
                            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event">

                            <template slot-scope="props">

                                <o-table-column field="name" label="Name" sortable>
                                    {{ props.row.name }}
                                </o-table-column>

                                <o-table-column field="pendingTime" label="Pending Time" sortable>
                                    {{ props.row.pendingTime }}
                                </o-table-column>

                                <o-table-column label="">
                                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                                        <button class="button" slot="trigger">
                                            <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                        </button>
                                        <o-dropdown-item has-link><router-link :to="{ name: 'contacts.show', params: { slug: props.row.name } }">View</router-link></o-dropdown-item>
                                    </o-dropdown>
                                </o-table-column>

                            </template>

                            <div slot="empty" class="has-text-centered">
                                No files are uploaded yet
                            </div>
                        </o-table>
                    </o-tab-item>
                    <o-tab-item label="Pending Proposals">
                        <o-table
                            :data="proposals"
                            :bordered="isBordered"
                            :striped="isStriped"
                            :narrowed="isNarrowed"
                            :checkable="isCheckable"
                            :loading="isLoading"
                            :mobile-cards="hasMobileCards"
                            :paginated="isPaginated"
                            :per-page="perPage"
                            :pagination-simple="isPaginationSimple"
                            default-sort="user.first_name"
                            :selected.sync="selected"
                            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event">

                            <template slot-scope="props">

                                <o-table-column field="name" label="Name" sortable>
                                    {{ props.row.name }}
                                </o-table-column>

                                <o-table-column field="pendingTime" label="Pending Time" sortable>
                                    {{ props.row.pendingTime }}
                                </o-table-column>

                                <o-table-column label="">
                                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                                        <button class="button" slot="trigger">
                                            <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                        </button>
                                        <o-dropdown-item has-link><router-link :to="{ name: 'proposals.show', params: { slug: props.row.name } }">View</router-link></o-dropdown-item>
                                    </o-dropdown>
                                </o-table-column>

                            </template>

                            <div slot="empty" class="has-text-centered">
                                No files are uploaded yet
                            </div>
                        </o-table>
                    </o-tab-item>
                </o-tabs >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                contacts: [
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                    {"id": 1, "name": "Chelsea", "pendingTime": "12 days"},
                    {"id": 2, "name": "Emily", "pendingTime": "2 days"},
                    {"id": 3, "name": "John", "pendingTime": "2 hours"},
                ],
                proposals: [
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                    {"id": 1, "name": "1  old country rd -1074", "pendingTime": "3 days"},
                    {"id": 2, "name": "1 Albertson Avenue -2407", "pendingTime": "1 day"},
                    {"id": 3, "name": "1 Battery Park Plaza National Development Council-2666", "pendingTime": "13 hours"},
                ],
                checkedRows: [],
                selected: {},
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10
            }
        },
        methods: {
            clearSelected() {
                this.selected = {}
            },
            clearCheckedRows() {
                this.checkedRows = []
            }
        }
    }
</script>